<template>
  <img :src="homePage" alt="" width="100%" />
</template>

<script>
import homePage from "@/assets/images/homePage.svg";
export default {
  name: "SpeechSkeleton",
  data() {
    return {
      homePage,
    };
  },
};
</script>

<style scoped></style>
